import Piece from './Piece.js'

export default class Duo extends Piece {
  constructor () {
    super(2)
  }
}
